module.exports = __webpack_public_path__ + "img/IMG_8473_P_L.cb838d65.webp";